function formatPrice(amount?: number | null, currency?: string | null): string {
  if (amount === undefined || amount === null) {
    return "—";
  }
  return `${amount} ${currency ?? ""}`.trim();
}

export default formatPrice;
